import { DonationFormPreviewOutput, TicketingPreviewOutput } from "@/common/types/trpc";

type DashboardForm<Form, OptionalField extends keyof Form> = Omit<Form, OptionalField> & {
  [Field in OptionalField]?: Form[Field] | null;
};

export const toTicketingPreview = (
  ticketing: DashboardForm<TicketingPreviewOutput, "communicationPreferences" | "organization" | "ticketingFields">,
  fallbackOrganization?: TicketingPreviewOutput["organization"] | null
): TicketingPreviewOutput | null => {
  const organization = ticketing.organization ?? fallbackOrganization;
  if (!organization) {
    return null;
  }
  return {
    ...ticketing,
    organization,
    communicationPreferences: ticketing.communicationPreferences ?? [],
    ticketingFields: ticketing.ticketingFields ?? [],
  };
};

export const toDonationFormPreview = (
  donationForm: DashboardForm<
    DonationFormPreviewOutput,
    "communicationPreferences" | "organization" | "donationFormFields"
  >,
  fallbackOrganization?: DonationFormPreviewOutput["organization"] | null
): DonationFormPreviewOutput | null => {
  const organization = donationForm.organization ?? fallbackOrganization;
  if (!organization) {
    return null;
  }
  return {
    ...donationForm,
    organization,
    communicationPreferences: donationForm.communicationPreferences ?? [],
    donationFormFields: donationForm.donationFormFields ?? [],
  };
};
